import service from './service'

const getAllEmployees = async ({ commit }) => {
  const data = await (await service.getAllEmployees()).data

  console.log('result', data)

  await commit('SAVE_ALL_EMPLOYEES', data)
}

export default {
  getAllEmployees,
}
